/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import AddAdvertisement from "layouts/masterPage/advertisementPage/components/AddAdvertisement";

// Data
import FetchAdvertisementData from "layouts/masterPage/advertisementPage/data/advertisementTableData";

function AdvertisementPage() {
  const [open, setOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [severity, setSeverity] = useState("success");
  const [formData, setFormData] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  const addAdvertisement = () => {
    //open dialog box where add police form is displayed
    setOpen(true);
    setFormData({});
    setIsEdit(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccess = () => {
    setSnackbarOpen(true);
    setRefresh(!refresh);
    setSnackbarMsg(
      isEdit === true
        ? "Advertisement updated successfully!!"
        : "Advertisement created successfully!!"
    );
    setSeverity("success");
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleFailed = (msg) => {
    setSnackbarMsg(msg);
    setRefresh(!refresh);
    setSnackbarOpen(true);
    setSeverity("error");
  };

  const handleEditData = (data) => {
    setFormData(data);
    setOpen(true);
    setIsEdit(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar absolute isMini />
      <MDBox pt={8} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium"></MDTypography>
        <MDButton variant="gradient" color="dark" onClick={addAdvertisement}>
          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
          &nbsp;add new Advertisement
        </MDButton>
      </MDBox>
      <MDBox pt={8} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Advertisement List
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <FetchAdvertisementData onRefresh={refresh} editData={handleEditData} />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <Grid container justifyContent="space-between" alignItems="center">
          <DialogTitle>{isEdit === true ? "Edit Advertisement" : "Add Advertisement"}</DialogTitle>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              <Icon>close</Icon>
            </Button>
          </DialogActions>
        </Grid>
        <DialogContent>
          <AddAdvertisement
            onClose={handleClose}
            onSuccess={handleSuccess}
            onFailed={handleFailed}
            editFormData={formData}
          />
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={severity} sx={{ width: "100%" }}>
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default AdvertisementPage;
